<template>
  <div :id="id"/>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"
import { percent } from "@/support"

const props = defineProps({
  school: { type: Object, required: true },
})

const id = "acceptance_rate"

onMounted(() => {
  const admissions = props.school.recent_admissions.map((a) => {
    a.acceptance_rate = percent(a.offers_All, a.applications_All)

    return a
  })

  const key = "acceptance_rate"

  const options = {
    chart: { type: "spline", height: 300 },
    legend: { enabled: false },
    title: { text: "" },
    credits: { enabled: false },
    xAxis: {
      categories: admissions.map((a) => a.admission_year),
    },
    yAxis: { min: 0, max: 100, labels: { format: "{value}%" }, title: { text: "" }, allowDecimals: false },
    tooltip: {
      crosshairs: true,
      shared: true,
      headerFormat: '<span style="font-size: 16px;font-weight:600;">{point.key}</span><br/>',
      pointFormat: '<div style="font-size:14px;"><span style="color:{point.color}">●</span> {series.name}: {point.y}%</div>',
    },
    plotOptions: {
      spline: {
        marker: {
          radius: 2, lineColor: "#666666", lineWidth: 1,
        },
      },
    },
    series: [
      {
        name: "Acceptance rate",
        data: admissions.map((a, index) => ({
          y: a[key],
          change: index ? Math.round((a[key] - admissions[index - 1][key]) * 10) / 10 : null,
        })),
        dataLabels: {
          allowOverlap: false,
          useHTML: true,
          x: 0,
          y: -1,
          enabled: true,
          formatter() {
            if (this.point.change == 0) {
              return `${this.point.change}%`
            }

            if (!this.point.change) {
              return null
            }

            if (this.point.change > 0) {
              return `<span class="text-green">+${this.point.change}%</span>`
            }

            return `<span class="text-red-500">${this.point.change}%</span>`
          },
        },
      },
    ],
  }
  new Highcharts.chart(id, options)
})
</script>
